import { Route } from "@bca-shared/models/_enums";
import { IProduct } from "@bca-shared/models/product";

export const cloneProducts = (products: IProduct[]): IProduct[] => {
  return products
    ? [...products].map((product) => {
        const { addons, services } = product;
        return {
          ...product,
          addons: addons ? addons.map((addon) => ({ ...addon })) : null,
          services: services
            ? services.map((service) => ({ ...service }))
            : null,
        };
      })
    : null;
};

export const cloneProduct = (product: IProduct): IProduct => {
  return product
    ? {
        ...product,
        addons: product.addons
          ? product.addons.map((addon) => ({ ...addon }))
          : [],
        services: product.services
          ? product.services.map((service) => ({ ...service }))
          : [],
      }
    : null;
};

export const infoMessagesFilter = (): string[] => {
  return [
    "De actiecode is niet (meer) geldig.",
    "The promotional code is not or no longer valid.",
  ];
};

export const icons = [
  { identifier: "TAX", url: "taxi.png" },
  { identifier: "INT", url: "internationaal.png" },
  { identifier: "OVF", url: "bikeShed.png" },
  { identifier: "QPK", url: "parking.png" },
  { identifier: "DEF", url: "bikeElectric.png" },
  { identifier: "DLA", url: "carshare.png" },
  { identifier: "DLF", url: "bikeShare.png" },
  { identifier: "DLS", url: "scooterShare.png" },
];

export const pageData = [
  { route: Route.COMPOSE, title: "COMPOSE.TAB_TITLE", header: "" },
  { route: Route.USER_DATA, title: "USER_DATA.TAB_TITLE", header: "" },
  { route: Route.VERIFY, title: "VERIFY.TAB_TITLE", header: "" },
  { route: Route.COMPANY_DATA, title: "COMPANY_DATA.TAB_TITLE", header: "" },
  { route: Route.AGREEMENT, title: "AGREEMENT.TAB_TITLE", header: "" },
];
